import SlugForm, { TSlugValue } from '../components/SlugForm'

type Props = {
  onSubmit: (v: { email: TSlugValue['email'] }, isOrgName: boolean) => void
  fetching: boolean
}

const Slug = ({ onSubmit, fetching }: Props): JSX.Element => (
  <SlugForm
    onSubmit={(values: TSlugValue, isOrgName: boolean): void =>
      onSubmit({ email: values.email }, isOrgName)
    }
    fetching={fetching}
  />
)

export default Slug
